import { SET_IS_FILE_UPLOADING } from '../actions/fileUploadAction';

const initialState = {
   isUploading: false,
};

const fileUploadReducer = (state = initialState, action) => {
   switch (action.type) {
      case SET_IS_FILE_UPLOADING:
         return {
            ...state,
            isUploading: action.isUploading
         };
      default:
         return state;
   }
};

export default fileUploadReducer;
